<template>
  <div class="login-page">
    <!-- 使用 van-nav-bar 替代 HeaderCom -->
    <van-nav-bar
      title="用户登录"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      class="custom-nav-bar"
    >
      <template #right>
        <van-icon name="wap-home" size="20" @click="goHome" />
      </template>
    </van-nav-bar>

    <div class="login-container">
      <!-- Logo 和品牌区域 -->
      <div class="brand-section">
        <div class="logo-wrapper">
          <img
            src="https://www.ptty.com.cn/wap/logo.png"
            alt="跑兔体育"
            class="brand-logo"
          />
        </div>
        <div class="brand-name">跑兔体育</div>
        <div class="brand-slogan">专业的体育赛事服务平台</div>
      </div>

      <div class="login-card">
        <div class="login-title">用户登录</div>

        <div class="form-section">
          <van-field
            v-model="ryInfo.TEL"
            label="手机号"
            placeholder="请输入手机号"
            class="login-field"
          />
          <van-field
            v-model="ryInfo.PWD"
            label="密码"
            type="password"
            placeholder="请输入密码"
            class="login-field"
          />
        </div>

        <div
          class="register-link"
          @click="registerUrl"
          v-if="ryInfo.openIdEn && ryInfo.openIdEn.length > 0"
        >
          立即注册
        </div>

        <van-button
          type="primary"
          block
          @click="login"
          class="login-btn"
          v-if="ryInfo.openIdEn && ryInfo.openIdEn.length > 0"
        >
          登录
        </van-button>
      </div>
    </div>

    <loading-com />
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
import md5 from "js-md5";
export default {
  components: { LoadingCom },
  name: "LoginIndex",

  data() {
    return {
      ryInfo: {
        NIC: "",
        TEL: "",
        TELEN: "",
        PWD: "",
        isLogin: false,
        openIdEn: ""
      },
      code: "",
      isOpenIdExists: false
    };
  },
  created() {
    this.utilPost = this.$util.handler;
  },
  mounted() {
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.isOpenIdExists = false;
      openIdEn = "";
      var that = this;
      this.utilPost.getOpenId(function(openId) {
        that.ryInfo.openIdEn = openId;
        that.checkAutoLogin();
      });
    } else {
      this.isOpenIdExists = true;
      this.ryInfo.openIdEn = openIdEn;
      this.checkAutoLogin();
    }

    // this.ryInfo.openIdEn =
    //   "3265744d315836513630444565746138626c576661514e61686641734a597075654c74336b656b48686f343d";
    // return;
  },
  destroyed() {
    this.code = null;
  },
  methods: {
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },

    // 返回主页
    goHome() {
      const routeValue = localStorage.getItem("routeValue");
      if (routeValue) {
        this.$router.push({ path: "/" + routeValue });
      } else {
        this.$router.push({ path: "/" });
      }
    },

    checkAutoLogin() {
      // alert(this.ryInfo.openIdEn);
      if (this.ryInfo.openIdEn.length > 0) {
        //获取OpenId
        var busData = {
          code: "",
          openIdEn: this.ryInfo.openIdEn
        };
        // alert(JSON.stringify(busData));
        var paramData = {
          headerData: {
            ssid: "",
            op: "wapGL", //反射名称
            methodName: "getOpenId" //对应的方法名
          },
          busData: busData //参数内容
        };
        this.utilPost.paramData = paramData;
        this.utilPost.sendPost().then(data => {
          // alert(JSON.stringify(data));
          if (!data.isSuccess) {
            alert(data.msg);
            return;
          }
          let openIdEn = data.content.OPENIDEN;
          this.ryInfo.openIdEn = openIdEn;
          localStorage.setItem("openIdEn", openIdEn);
          if (data.code === "SUCCESS") {
            localStorage.setItem("ryInfo", JSON.stringify(data.content));
            // 自动登录成功后的跳转
            this.redirectAfterLogin();
            return;
          }
        });
      }
    },

    login() {
      var busData = {
        ryInfo: this.ryInfo
      };
      this.ryInfo.PWD = md5(this.ryInfo.PWD);
      var paramData = {
        headerData: {
          ssid: "",
          op: "wapGL", //反射名称
          methodName: "login" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          this.ryInfo.PWD = "";
          alert(data.msg);
          return;
        }
        if (data.code === "NOUSER") {
          //跳转到注册界面，携带 redirect 参数
          this.$router.push({
            path: "/registerIndex",
            query: {
              openIdEn: this.ryInfo.openIdEn,
              redirect: this.$route.query.redirect // 传递来源路径
            }
          });
        } else {
          localStorage.setItem("ryInfo", JSON.stringify(data.content));
          // 登录成功后的跳转
          this.redirectAfterLogin();
        }
      });
    },

    // 登录/注册成功后的跳转逻辑
    redirectAfterLogin() {
      // 优先使用 localStorage 中保存的上一个路由
      const previousRoute = localStorage.getItem("previousRoute");

      if (
        previousRoute &&
        previousRoute !== "/loginIndex" &&
        previousRoute !== "/registerIndex"
      ) {
        // 有上一个路由且不是登录/注册页，跳转回去
        localStorage.removeItem("previousRoute"); // 清除已使用的路由
        this.$router.replace(previousRoute);
      } else {
        // 默认跳转到首页
        const routeValue = localStorage.getItem("routeValue");
        if (routeValue) {
          this.$router.replace("/" + routeValue);
        } else {
          this.$router.replace("/");
        }
      }
    },

    registerUrl() {
      //跳转到注册界面
      this.$router.push({
        path: "/registerIndex",
        query: {
          openIdEn: this.ryInfo.openIdEn
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
/* 字体渲染优化 */
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 页面容器 */
.login-page {
  min-height: 100vh;
  background: #f5f6fa;
}

/* 导航栏 */
.custom-nav-bar {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);

  /deep/ .van-nav-bar__title {
    color: #fff;
    font-weight: 700;
    font-size: 1.125rem;
  }

  /deep/ .van-nav-bar__text,
  /deep/ .van-icon {
    color: #fff;
  }
}

/* 登录容器 */
.login-container {
  padding: 2rem 1rem 3rem;
}

/* Logo 和品牌区域 */
.brand-section {
  text-align: center;
  margin-bottom: 2rem;
}

.logo-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}

.brand-logo {
  width: 5rem;
  height: 5rem;
  object-fit: contain;
  animation: logoFadeIn 0.8s ease;
}

@keyframes logoFadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.brand-name {
  font-size: 1.75rem;
  font-weight: 700;
  color: #185f9b;
  margin-bottom: 0.5rem;
  letter-spacing: 2px;
  animation: slideDown 0.6s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-1rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.brand-slogan {
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
  animation: fadeIn 0.8s ease 0.2s both;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* 登录卡片 */
.login-card {
  background: #fff;
  padding: 1.5rem;
  border-radius: 0.875rem;
  box-shadow: 0 2px 12px rgba(24, 95, 155, 0.15);
  animation: cardSlideUp 0.6s ease 0.3s both;
}

@keyframes cardSlideUp {
  from {
    opacity: 0;
    transform: translateY(1.5rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 登录标题 */
.login-title {
  padding: 0.5rem 0 1rem;
  text-align: center;
  font-size: 1.125rem;
  font-weight: 700;
  color: #333;
  border-bottom: 2px solid #e9ecef;
  margin-bottom: 1.5rem;
}

/* 表单区域 */
.form-section {
  margin-bottom: 1rem;
}

/* 登录字段 */
.login-field {
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  overflow: hidden;

  /deep/ .van-field__label {
    font-size: 1rem;
    color: #6b7280;
    font-weight: 500;
  }

  /deep/ .van-field__control {
    color: #1f2937;
    font-weight: 500;
  }
}

/* 注册链接 */
.register-link {
  color: #185f9b;
  text-align: right;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 1.5rem;
  transition: color 0.3s ease;

  &:hover {
    color: #1a6ba8;
  }

  &:active {
    color: #145080;
  }
}

/* 登录按钮 */
.login-btn {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  border: none;
  font-weight: 600;
  font-size: 1rem;
  height: 2.75rem;
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(24, 95, 155, 0.3);

  &:active {
    transform: scale(0.98);
    box-shadow: 0 2px 8px rgba(24, 95, 155, 0.3);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginIndex/LoginIndex.vue